import { instance } from "./interceptors"



export const allWarhousesUnit = async() => {
    const response = await instance.get('/api/branch/all')
    return response.data
}

export const warhouseProductsUnit = async(params) => {
    const query = (params) ? `/?branchType=${params.type}&branchId=${params.branch}` : ''
    const response = await instance.get('/api/warehouse'+query)
    return response.data
}


export const warhouseUpdateUnit = async(body) => {    
    const data = {
        products: body.map(el => ({
            warehouse_product_id: el.id,
            current_qnt: el.quantity,
            actual_qty: el.current_qnt,
        }))
    }
    const response = await instance.post('/api/warehouse/update', data)
    return response.data
}


export const transferWarehouseUnit = async(body) => {    
    const response = await instance.post('/api/warehouse/transfer', body)
    return response.data
}


export const warehouseDocumentDetailUnit = async(date) => {    
    const response = await instance.get(`/api/warehouse/document/detail?date=${date}`)
    return response.data
}

export const warehouseDocumentUnit = async(id) => {    
    const response = await instance.get(`/api/warehouse/document/${id}`)
    return response.data
}


export const wasteProductsUnit = async() => {    
    const response = await instance.get(`/api/waste/products`)
    return response.data
}



